import type * as Style from '../../index.js'
import { Length, NullLength, NumberValue, pickNonEmpty, ValidatedArray } from '../../values/index.js'

export const Cell = ({ row, column }: { row?: any; column?: any } = {}) => {
  return {
    row: NumberValue(row) ?? 1,
    column: NumberValue(column) ?? 1
  }
}

export const CellSpan = ({ from, to }: { from?: any; to?: any } = {}) => {
  return {
    from: Cell(from),
    to: to
      ? Cell(to)
      : {
          row: Cell(from).row + 1,
          column: Cell(from).column + 1
        }
  }
}

export const CellSize = ({ min, max }: { min?: any; max?: any } = {}) => {
  return {
    min: Length(min),
    max: NullLength(max) === null ? Length({ unit: 'fr', value: 1 }) : Length(max)
  }
}
export const Item = ({ from, to, order }: { from?: any; to?: any; order?: number }) => {
  return {
    ...CellSpan({ from, to }),
    order: NumberValue(order)
  }
}
export const Row = ({ min, max }: { min?: any; max?: any }) => {
  return {
    min: Length(min),
    max: NullLength(max) === null ? null : Length(max)
  }
}

export const default12Columns = Array.from(Array(12)).map(() => CellSize({ min: null, max: null }))
export const default5Rows = [
  Row({ min: 36, max: 36 }),
  Row({ min: 36, max: 36 }),
  Row({ min: 36, max: 36 }),
  Row({ min: 36, max: 36 }),
  Row({ min: 36 })
]
export const Props = (props: any = {}) => {
  return {
    columns: [ValidatedArray(CellSize, props.columns), default12Columns].reduce(pickNonEmpty),
    rows: [ValidatedArray(Row, props.rows), default5Rows].reduce(pickNonEmpty),
    items: ValidatedArray(Item, props.items)
  }
}

export type Item = ReturnType<typeof Item>
export type Cell = ReturnType<typeof Cell>
export type CellSpan = ReturnType<typeof CellSpan>
export type CellSize = ReturnType<typeof CellSize>
export type Props = ReturnType<typeof Props>
export const validate = () => true
export const fix = (props: Props, styles: Style.Rule[]) => props
export const label = 'Grid'
export const type = 'grid'
export const property = 'gridIds'
export const category = 'aspect'
export const summarize = (props: Props, styles?: Style.Rule[], formId?: string) =>
  `${props.rows.length} / ${props.columns.length}`
